// 住院管家模块
const state = {
  records: [],
  index: 0
}

const getters = {
  information: state => state.records[state.index]
}

const mutations = {
  updateRecords (state, list) {
    state.records = list
  },
  updateIndex (state, index) {
    state.index = index
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/manager.js